export default function ccyFormat(num) {
  debugger;
  return num ? num.toFixed(2) : num;
}
